<template>
	<div class="msg">
		<userMenu></userMenu>
		<div class="msg-box">
			<div class="msg-send">
				<div class="msg-tip">
					非常感谢你能够参加调查，提供你的看法与意见，希望能够得到你的大力支持与合作。我们极其重视数据安全，绝不会泄露任何你的隐私信息。现在我们就马上开始吧！
				</div>
				<div class="msg-item">
					<div class="msg-item-title">
						1. 您的职业是
					</div>
					<el-select v-model="zhiye" size="small" style="width: 100%;" placeholder="请选择您当前职业">
						<el-option v-for="item in jobData" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="msg-item">
					<div class="msg-item-title">
						2. 您对北域视界（ AI 提示词）、创作中心的建议或意见
					</div>
					<div class="msg-item-stitle">
						被采纳可获得站内奖励
					</div>
					<el-input v-model="jianyi" type="textarea" rows="5"></el-input>
				</div>
				<div class="msg-item">
					<div class="msg-item-title">
						3. 您希望本站增加什么类型的素材
					</div>
					<el-input v-model="sucai" size="small" placeholder="请输入素材类型或名称"></el-input>
				</div>
				<div class="msg-item">
					<div class="msg-item-title">
						4. 您可能推荐本站给有需要的创作者么
					</div>
					<div class="msg-item-stitle">
						1星为不可能，5星为极有可能
					</div>
					<el-rate v-model="tuijian" show-text></el-rate>
				</div>
				<div class="msg-item">
					<div class="msg-item-title">
						5. 如果您愿意接受回访，请留下您的联系方式
					</div>
					<el-select v-model="lianxi" size="small" style="width: 100px;">
						<el-option label="微信" value="wx"></el-option>
						<el-option label="电话" value="phone"></el-option>
						<el-option label="邮箱" value="email"></el-option>
						<el-option label="QQ" value="qq"></el-option>
					</el-select>
					<el-input v-model="fangshi" size="small" placeholder="请输入联系方式" style="width: 395px;"></el-input>
				</div>
				<div class="msg-item" style="text-align: center;padding-top: 30px;">
					<el-button type="primary" style="width: 200px;" @click="suggest">立即提交</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				jobData: [{
						"label": "政府/事业单位工作人员",
						"value": "gov"
					},
					{
						"label": "企业管理人员",
						"value": "manager"
					},
					{
						"label": "企业普通职员",
						"value": "staff"
					},
					{
						"label": "IT技术/程序员",
						"value": "it"
					},
					{
						"label": "市场/销售",
						"value": "sale"
					},
					{
						"label": "运营/新媒体",
						"value": "operate"
					},
					{
						"label": "财务/会计",
						"value": "finance"
					},
					{
						"label": "人力资源",
						"value": "hr"
					},
					{
						"label": "设计相关",
						"value": "designer"
					},
					{
						"label": "教师",
						"value": "teacher"
					},
					{
						"label": "医护人员",
						"value": "medical"
					},
					{
						"label": "个体工商户",
						"value": "business"
					},
					{
						"label": "自由职业者",
						"value": "freelance"
					},
					{
						"label": "在校学生",
						"value": "student"
					},
					{
						"label": "制造业工人",
						"value": "worker"
					},
					{
						"label": "服务业从业者",
						"value": "service"
					},
					{
						"label": "务农人员",
						"value": "farmer"
					},
					{
						"label": "离退休人员",
						"value": "retire"
					},
					{
						"label": "暂无职业",
						"value": "unemployed"
					},
					{
						"label": "其他",
						"value": "other"
					}
				],
				zhiye: '',
				jianyi: '',
				tuijian: '',
				lianxi: 'wx',
				fangshi: '',
				sucai: ''
			}
		},
		methods:{
			suggest(){
				if(this.zhiye == ''){
					this.$message.error('请选择职业');
					return
				}
				if(this.jianyi == ''){
					this.$message.error('请输入建议或意见');
					return
				}
				let params = {
					token:api.getCookie('token'),
					zhiye:this.zhiye,
					jianyi:this.jianyi,
					sucai:this.sucai,
					tuijian:this.tuijian,
					fangshi:this.fangshi,
					lianxi:this.lianxi
				}
				api.saveSuggest(params).then(res=>{
					if(res.code==200){
						this.$message.success(res.msg);
						this.zhiye = ''
						this.jianyi = ''
						this.sucai = ''
						this.tuijian = ''
						this.fangshi = ''
						this.lianxi = 'wx'
					}else{
						this.$message.error(res.msg);
					}
				})
			},
		}
	}
</script>

<style>
	.msg-box{
		padding-left: 220px;
	}
	.msg-item-stitle{
		font-size: 12px;
		color: #999;
		padding-bottom: 10px;
	}
	.msg-item-title{
		font-size: 14px;
		font-weight: bold;
		padding-bottom: 10px;
	}
	.msg-item{
		margin-top: 40px;
	}
	.msg-tip{
		font-size: 14px;
		color: #666;
		line-height: 24px;
	}
	.msg-list{
		flex: 1;
	}
	.msg-send{
		width: 700px;
		height: 100vh;
		background-color: #fff;
		padding: 50px 100px;
		margin: auto;
		box-sizing: border-box;
	}
	.msg {
		width: 100%;
		min-height: 100vh;
		background-color: var(--bg3);
	}
</style>



// WEBPACK FOOTER //
// src/page/msg.vue